import { populateMenu } from "./menu";

/**
 * Toggles the visibility of the mobile menu.
 * If the menu is currently open, it closes it.
 * If the menu is currently closed, it opens it and populates it with the current menu.
 *
 * @param {HTMLElement} menu - The mobile menu element.
 */
export function toggleMobile(menu: HTMLElement) {
  const className = "mobile-open";
  if (menu.classList.contains(className)) {
    menu.classList.remove(className);
  } else {
    showMobile(menu.dataset.current ?? "");
    menu.classList.add(className);
  }
}

/**
 * Shows the mobile menu and populates it with the specified menu.
 *
 * @param {string} id - The id of the menu to show.
 */
function showMobile(id: string) {
  const mobileMenu = document.getElementById("mobile-menu");
  if (!mobileMenu) return;
  const mobileMain = document.getElementById("mobile-main");
  if (!mobileMain) return;
  if (!id) {
    id = "root";
  }
  mobileMenu.dataset.current = id;
  const parent = populateMenu(mobileMain, id);
  linkParent(parent);
  activateMobile(mobileMain);
}

/**
 * Adds a "back" button to the mobile menu that links to the parent menu.
 *
 * @param {string} parent - The id of the parent menu.
 */
function linkParent(parent: string) {
  const mobileTop = document.getElementById("mobile-top");
  if (!mobileTop) return;

  while (mobileTop.lastChild) {
    mobileTop.removeChild(mobileTop.lastChild);
  }

  if (parent) {
    const button = document.createElement("button");
    button.className = "back";
    const buttonText = document.createTextNode("Takaisin");
    button.appendChild(buttonText);
    button.addEventListener("click", (event) => {
      showMobile(parent);
    });

    mobileTop.appendChild(button);
  }
}

/**
 * Activates the mobile menu by adding click event listeners to all buttons that open a submenu.
 *
 * @param {HTMLElement} menu - The mobile menu element.
 */
function activateMobile(menu: HTMLElement) {
  for (const button of menu.querySelectorAll("[data-menu-open]")) {
    if (button instanceof HTMLElement) {
      const id = button.dataset.menuOpen;
      if (id) {
        button.addEventListener("click", (event) => {
          showMobile(id);
        });
      }
    }
  }
}
